export const passwordRequirements = [
  { id: 'length', label: 'minimum 8 znaków', test: (p: string) => p.length >= 8 },
  { id: 'digit', label: 'co najmniej 1 cyfra', test: (p: string) => /\d/.test(p) },
  {
    id: 'upper',
    label: 'co najmniej 1 wielka litera',
    test: (p: string) => /\p{Lu}/u.test(p),
  },
  {
    id: 'special',
    label: 'co najmniej 1 znak specjalny',
    test: (p: string) => /[^\p{L}\p{N}]/u.test(p),
  },
] as const
